module.exports = __webpack_public_path__ + "static/media/feat-curtains-img2.e9ab9dec.jpg";